import React, { useEffect, useState } from "react";
import "./css/userProfile.css";
import CustomSvg from "../svgs/CustomSvg";
import { HiUsers } from "react-icons/hi";
import { IoMdNotifications } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { IoLockClosed } from "react-icons/io5";
import { GrTransaction } from "react-icons/gr";
import { BsBank } from "react-icons/bs";
import { GoInfo } from "react-icons/go";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { useNavigate, useLocation } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import FloatingBtn from "../customBtns/FloatingBtn";

const navLinks = [
  {
    name: "user info",
    path: "user-profile",
    Icon: () => <LuUser size={18} color="#6499FF" />,
  },
  {
    name: "invite friends",
    path: "invite-friends",
    Icon: () => <HiUsers size={18} color="#6499FF" />,
  },
  {
    name: "security",
    path: "security",
    Icon: () => <IoLockClosed size={18} color="#6499FF" />,
  },
  {
    name: "Add BANK",
    path: "add-bank",
    Icon: () => <BsBank size={18} color="#6499FF" />,
  },
  {
    name: "help",
    path: "help",
    Icon: () => <GoInfo size={18} color="#6499FF" />,
  },
];

export default function UserProfileNav({ userLogout }) {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);

  const pathname = useLocation().pathname;

  const [activeNav, setActiveNav] = useState("user-profile");
  const [showOffCanvasNav, setShowOffCanvasNav] = useState(false);

  const openOffCanvasNav = () => setShowOffCanvasNav(true);
  const closeOffCanvasNav = () => setShowOffCanvasNav(false);

  useEffect(() => {
    if (pathname.toLowerCase().includes("user-profile/help")) {
      setActiveNav("help");
    } else if (pathname.toLowerCase().includes("user-profile/security")) {
      setActiveNav("security");
    } else if (pathname.toLowerCase().includes("user-profile/notifications")) {
      setActiveNav("notifications");
    } else if (pathname.toLowerCase().includes("user-profile/invite-friends")) {
      setActiveNav("invite-friends");
    } else if (pathname.toLowerCase().includes("user-profile/add-bank")) {
      setActiveNav("add-bank");
    } else if (
      pathname.toLowerCase().includes("user-profile/transaction-history")
    ) {
      setActiveNav("transaction-history");
    } else if (pathname.toLowerCase().includes("user-profile")) {
      setActiveNav("user-profile");
    } else {
      setActiveNav("");
    }
  }, [pathname]);

  const displayNavLinks = navLinks.map(({ name, path, Icon }, i) => {
    const isActive = activeNav === path;
    const onNavClick = () => {
      closeOffCanvasNav();
      navigateTo(
        path === "user-profile" ? `/${path}` : `/user-profile/${path}`
      );
    };

    return (
      <button
        key={i}
        onClick={onNavClick}
        className={`flex items-center w-full text-left py-2 px-3 rounded-lg transition ${
          isActive ? "bg-[rgba(189,49,147,0.1)]" : "hover:bg-gray-800"
        }`}
      >
        <div className="p-2 rounded-lg bg-gray-800">
          <Icon />
        </div>

        <p
          className={`ml-4 text-sm font-medium capitalize font-poppins ${
            isActive ? "text-pink-500" : "text-white"
          }`}
        >
          {name}
        </p>
      </button>
    );
  });

  return (
    <div className="w-full user-profile-nav-container scrollbar-hide">
      <div>
        {/* Header */}
        <div className="flex items-center justify-center mb-4 pb-3">
          {/* <h1 className="text-2xl font-extrabold text-center text-white font-quantico m-0 p-0">
            User <span className="text-pink-600">Profile</span>
          </h1> */}

          {/* Settings Icon for small screens */}
          {/* <div
            onClick={openOffCanvasNav}
            className="lg:hidden md:hidden flex items-center justify-center p-2 rounded-lg cursor-pointer bg-[rgba(189,49,147,0.1)] opacity-80"
            aria-label="Open navigation settings"
          >
            <CustomSvg name="settings" />
          </div> */}
        </div>

        {/* Sidebar navigation - visible on medium and larger screens */}
        <div className="hidden md:flex flex-col h-full">
          {/* Navigation Links */}
          <div className="flex-grow overflow-auto scrollbar-hide user-profile-nav-links">
            {displayNavLinks}
          </div>

          {/* Logout Button */}
          <div className="mt-4 user-profile-nav-footer">
            <div
              onClick={userLogout}
              className="flex items-center cursor-pointer hover:bg-gray-700 p-3 rounded-lg transition"
              role="button"
              aria-label="Logout"
            >
              <div className="user-profile-nav-nav-link-icon-container p-2 bg-gray-800 rounded-lg">
                <RiLogoutBoxRLine size={18} color="#FF1843" />
              </div>
              <p className="mx-4 text-white text-sm font-poppins font-medium capitalize">
                Logout
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Offcanvas modal */}
      <Offcanvas show={showOffCanvasNav}>
        <div className="w-full h-full bg-[#130828]">
          <div className="w-full h-full p-4 navContainer flex flex-col">
            <div className="flex items-center mb-5 justify-between">
              <h1 className="m-0 p-0 font-extrabold text-2xl text-white font-quantico">
                User <span className="create-lobby-title-span">Profile</span>
              </h1>
              <div onClick={closeOffCanvasNav} className="cursor-pointer">
                <CustomSvg name="x" color="#FFF" />
              </div>
            </div>

            <div className="flex flex-col justify-between h-full">
              <div className="user-profile-nav-links scrollbar-hide flex-grow overflow-auto">
                {displayNavLinks}
              </div>

              <div className="user-profile-nav-footer mt-4">
                <div
                  onClick={userLogout}
                  className="flex items-center cursor-pointer"
                >
                  <div className="p-3 user-profile-nav-nav-link-icon-container">
                    <RiLogoutBoxRLine size={18} color="#FF1843" />
                  </div>

                  <div className="mx-4">
                    <p className="m-0 p-0 text-white text-sm font-poppins font-medium capitalize">
                      logout
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas>
    </div>
  );
}
